import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import './Header.css';
class Header extends Component {
	render() {
		return (
			<div className='head-container'>
				<Grid fluid>
					<Row>
						<Col xs={12} md={2}>
							logo
						</Col>
						<Col xs={12} md={6}>
							<p>Københavns 100 bedste reatauranter</p>
						</Col>
						<Col xs={12} md={2}>
							<input type='text'  />
							<button type="button">Søg</button>
						</Col>
						<Col xs={12} md={2}>
							burger
						</Col>
					</Row>
				</Grid>
				
			</div>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js